import { BasicDialogHandler } from "@goodgamestudios/core";
import { Balancing } from "../../constants/shared/Balancing";
import { Poker2Model } from "../../model/Poker2Model";
import { PokerTextHelper } from "../helper/PokerTextHelper";
import { Poker2BrokeDialogProperties } from "./Poker2BrokeDialogProperties";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2BrokeDialog extends Poker2Dialog {
    public static NAME: string = "Poker2BrokeDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        super.applyProperties();
        switch (this.noMoneyDialogProperties.count) {
            case 1:
                this.brokeDialog.gotoAndStop(1);
                this.brokeDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_player_broke_title");
                this.brokeDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_0");
                this.brokeDialog.txt_chips.text = String(this.noMoneyDialogProperties.chips);
                this.brokeDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
                this.brokeDialog.txt_copy_tipp.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_0_tipp");
                break;
            case 2:
                if (!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified) {
                    this.brokeDialog.gotoAndStop(2);
                    this.brokeDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_player_broke_title");
                    this.brokeDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_1");
                    this.brokeDialog.txt_chips.text = PokerTextHelper.getShortGroupNumberString(5000);
                    this.brokeDialog.btn_ok.label = Poker2Model.languageData.getTextById("menu_btn_verifyemail");
                } else {
                    this.brokeDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_player_broke_title");
                    this.brokeDialog.gotoAndStop(3);
                    this.brokeDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_2");
                    this.brokeDialog.txt_chips.text = "";
                    this.brokeDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_payment_btn");
                    this.brokeDialog.txt_copy_tipp.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_2_tipp");
                }
                break;
            case 3:
            case 4:
                this.brokeDialog.gotoAndStop(3);
                this.brokeDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_player_broke_title");
                this.brokeDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_payment_btn");
                this.brokeDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_2");
                this.brokeDialog.txt_copy_tipp.text = Poker2Model.languageData.getTextById("dialog_player_broke_copy_2_tipp");
                this.brokeDialog.txt_chips.text = "";
                break;

        }
        this.brokeDialog.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.brokeDialog.btn_close:
                this.hide();
                break;
            case this.brokeDialog.btn_ok:
                switch (this.noMoneyDialogProperties.count) {
                    case 2:
                        if (!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified)
                            BasicDialogHandler.getInstance().registerDialogs("Poker2MailVerificationDialog", null, true, BasicDialogHandler.PRIORITY_TOP);
                        this.hide();
                        break;
                    case 3:
                    case 4:
                        this.controller.onClickMoreMoney(null);
                        this.hide();
                        break;
                    default:
                        this.hide();
                }
                break;
        }

    }

    protected get noMoneyDialogProperties(): Poker2BrokeDialogProperties {
        return this.properties as Poker2BrokeDialogProperties;
    }

    protected get brokeDialog(): Library.PokerInterface.PokerBroke {
        return this.disp as Library.PokerInterface.PokerBroke;
    }
}
import { Poker2MailVerificationDialog } from "./mailverification/Poker2MailVerificationDialog";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
